import PropTypes from 'prop-types';
// @mui
import { Box, Chip, useTheme } from '@mui/material';
import Done from '@mui/icons-material/Done';
import Close from '@mui/icons-material/Close';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';

export enum ChipType {
	APPROVED = 'approved',
	ERROR = 'error',
	REGULAR = 'regular',
	GRAYED = 'grayed',
	NATURAL = 'natural',
}
interface BaseProps {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
}

interface Props extends BaseProps {
	type?: ChipType;
	label?: string;
	icon?: string;
	color?: string;
	styleObj?: any;
}

export function CustomStatusChip(props: Props) {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const icon =
		props.type !== ChipType.APPROVED
			? {}
			: {
					icon: (
						<Done
							sx={{
								fontSize: '14px',
								padding: '2px',
								color: 'green!important',
								background: '#fff',
								borderRadius: '50%',
								marginLeft: '8px!important',
							}}
						/>
					),
			  };
	return (
		<Chip
			label={props?.label}
			sx={{
				width: 'auto',
				background: props.type !== ChipType.APPROVED ? '#fff' : theme.palette.root.brandSecondary,
				color:
					props.type !== ChipType.APPROVED
						? props.type === ChipType.ERROR
							? 'red'
							: props.type === ChipType.NATURAL
							? theme.palette.root.orange
							: 'inherit'
						: '#fff',
			}}
			{...icon}
		/>
	);
}

export function CustomChip(props: Props) {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const color = theme.palette.root.brandSecondary_012;
	let propsIcon: { icon?: any } = {};
	if (props.icon) {
		if (props.icon === 'done') {
			propsIcon.icon = <Done />;
		}
		if (props.icon === 'close') {
			propsIcon.icon = <Close />;
		}
	}
	return (
		<Chip
			label={props.label}
			sx={{
				width: 'auto',
				background: color,
				fontSize: '15px',
				opacity: props.type === ChipType.GRAYED ? 0.6 : 1,
				...props?.styleObj,
			}}
			{...propsIcon}
			/*props.icon &&
                <Done 
                    sx={{                        
                        fontSize:'18px',
                        padding:'2px',
                        fontFamily:'PloniBold',
                    }} 
                /> 
            }*/
		/>
	);
}

export function SquareChip(props: Props) {
	return (
		<Box
			sx={{
				width: '59px',
				height: '20px',
				borderRadius: '4px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				...props.styleObj,
			}}
		>
			{props.children}
		</Box>
	);
}

export const LightGreenChip = (props: BaseProps) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				padding: '4px 8px',
				backgroundColor: theme.palette.root.darkGrayed_024,
				borderRadius: '8px',
			}}
		>
			{props.children}
		</Box>
	);
};
